module.exports = __webpack_public_path__ + "img/free-days-modal-icon.636003fa.svg";